/* @flow */
import PropTypes from "prop-types";

import React from "react";
import { getIntlMixinForPhraseProject } from "shared/src/i18n/IntlRootMixin";
import GlobalHeader from "./globalheader/GlobalHeader";
import PageWrapperContent from "./PageWrapperContent";
import DocumentTitle from "./DocumentTitle";
import DocumentMetaTag from "./DocumentMetaTag";
import createReactClass from "create-react-class";
import { default as moment } from "moment";
import Tracking from "shared/src/uidispatcherapi/Tracking";
import PerformanceMeasureActions from "shared/src/actions/PerformanceMeasureActions";

import { locationChanged } from "../../utils/PageTrackingUtil";
import { deepEqual } from "shared/src/utils/util";
/**
 * A wrapper for all standard pages to provide the intl context, the header and document title.
 */
const PageWrapper = createReactClass({
    startTime: moment(),
    endTime: moment(),

    propTypes: {
        className: PropTypes.string,
        pageName: PropTypes.string,
        vertical: PropTypes.string.isRequired,
        disableFallbackTracking: PropTypes.bool,
        title: PropTypes.string.isRequired,
        additionalParamsForTitle: PropTypes.object,
        metaDescription: PropTypes.string,
        descriptionIsText: PropTypes.bool,
        additionalParamsForMetaDescription: PropTypes.object,
        children: PropTypes.node,
        scrollPositionResetBasedOn: PropTypes.any, // We reset the position if this indicator is changed
        hideGlobalHeader: PropTypes.bool, // for some public pages in non-mario countries
        location: PropTypes.any.isRequired,
        fullWidth: PropTypes.bool
    },

    mixins: [getIntlMixinForPhraseProject("EXPLORE")],

    componentWillMount() {
        this.startTime = moment();
        window.scrollTo(0, 0);
    },

    componentDidMount() {
        this.endTime = moment();
        const renderTime = moment.duration(this.endTime.diff(this.startTime)).asMilliseconds();
        PerformanceMeasureActions.renderSpeed(
            this.props.pageName ? this.props.pageName : "UNKNOWN",
            "mount",
            renderTime
        );

        if (!this.props.disableFallbackTracking) {
            Tracking.trackPageImpression(this.props.pageName, this.props.pageName);
        }
    },

    componentWillUpdate() {
        this.startTime = moment();
    },

    componentDidUpdate() {
        this.endTime = moment();
        const renderTime = moment.duration(this.endTime.diff(this.startTime)).asMilliseconds();
        PerformanceMeasureActions.renderSpeed(
            this.props.pageName ? this.props.pageName : "UNKNOWN",
            "update",
            renderTime
        );
    },

    componentWillReceiveProps(nextProps: { [x: string]: any }) {
        if (!deepEqual(nextProps.scrollPositionResetBasedOn, this.props.scrollPositionResetBasedOn)) {
            window.scrollTo(0, 0);
        }
        if (
            !this.props.disableFallbackTracking &&
            locationChanged(this.props.location, nextProps.location, this.props.pageName)
        ) {
            Tracking.trackPageImpression(this.props.pageName, this.props.pageName);
        }
    },

    render() {
        const className =
            "mfcss " + (this.props.hideGlobalHeader ? "" : "mfcss_wrapper ") + (this.props.className || "");

        return (
            <div className={className} role="region" aria-label="Landing Page Recommendations">
                {this.props.hideGlobalHeader ? null : (
                    <GlobalHeader location={this.props.location} __bypassReactAdapter />
                )}
                <PageWrapperContent
                    children={this.props.children}
                    vertical={this.props.vertical}
                    fullWidth={this.props.fullWidth}
                />
                <DocumentTitle k={this.props.title} {...this.props.additionalParamsForTitle} />
                {this.props.metaDescription ? (
                    <DocumentMetaTag
                        k={this.props.metaDescription}
                        descriptionIsText={this.props.descriptionIsText}
                        type={"description"}
                        {...this.props.additionalParamsForMetaDescription}
                    />
                ) : null}
            </div>
        );
    }
});

export default PageWrapper;
